import {EO, get} from "@green24/npm-javascript-utils";
import {GenericActions} from "../../actions/GenericActions";
import {StateHandlerV2} from "../StateHandlerV2";
import {AppUtils} from "../../../class/AppUtils";

const defaultInitialState = {
	data: null,
	edit: null,
	fetching: true,
	fetched: false,
	failed: false,
	sending: false,
	error: null,
	deleted: null,
	lastUpdate: undefined,
};

export class ItemStateHandler extends StateHandlerV2 {
	static get model() {
		return {
			defaultInitialState,
		}
	}

	constructor({
		actionPrefix,
		initialState = defaultInitialState,
		editOnly = false,
		sendingAsFetching = false,
		cloneBeforeEdit = true,
		shallowClone = true
	}) {
		super({initialState, defaultInitialState});

		this.actionPrefix = actionPrefix;
		this.editOnly = editOnly;
		this.sendingAsFetching = sendingAsFetching;
		this.cloneBeforeEdit = cloneBeforeEdit;
		this.shallowClone = shallowClone;
	}

	setupActions() {
		const {actionPrefix, editOnly, sendingAsFetching, initialState} = this;

		return {
			__INIT__: () => initialState,

			[`${actionPrefix}_${GenericActions.enum.actionType.FETCH_PENDING}`]: (state, action) => {
				return {
					...state,
					data: null,
					edit: null,
					fetching: true,
					fetched: false,
					failed: false,
					error: null,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.BACKGROUND_FETCH_PENDING}`]: (state, action) => {
				return {
					...state,
					fetching: true,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.FETCH_ABORTED}`]: (state, action) => {
				return {
					...state,
					fetching: false,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.FETCH_FULFILLED}`]: (state, action) => {
				return {
					...state,
					data: !editOnly ? action.payload : null,
					edit: editOnly ? action.payload : null,
					fetched: true,
					fetching: false,
					failed: false,
					error: null,
					lastUpdate: Date.now(),
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.FETCH_REJECTED}`]: (state, action) => {
				return {
					...state,
					fetching: false,
					failed: true,
					data: null,
					edit: null,
					fetched: false,
					error: action.payload,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.BACKGROUND_FETCH_REJECTED}`]: (state, action) => {
				return {
					...state,
					fetching: false,
					failed: true,
					error: action.payload,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_INIT}`]: (state, action) => {
				return {
					...state,
					edit: action.payload || EO(state.data).clone(true),
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_SET}`]: (state, action) => {
				return {
					...state,
					edit: action.payload,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_CANCEL}`]: (state, action) => {
				return {
					...state,
					edit: null,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_MODIFY}`]: (state, action) => {
				return {
					...state,
					...this._handleModify(state, action),
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_PENDING}`]: (state, action) => {
				return {
					...state,
					...(sendingAsFetching ? {fetching: true} : {sending: true}),
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_FULFILLED}`]: (state, action) => {
				return {
					...state,
					...(sendingAsFetching ? {fetching: false} : {sending: false}),
					// data: !editOnly ? EO(action.payload).clone(true) : null,//TBD: Test and remove if it doesn't affect anything
					// edit: editOnly ? EO().clone(true) : null,
					data: action.payload,
					edit: action.payload,
					lastUpdate: Date.now(),
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.ITEM_DELETE}`]: (state, action) => {
				return {
					...state,
					deleted: get(action, `payload.id`),
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.EDIT_REJECTED}`]: (state, action) => {
				return {
					...state,
					...(sendingAsFetching ? {fetching: false} : {sending: false}),
				};
			},
			//Supporting alias in case there is already an old dependency or a mistake happens
			[`${actionPrefix}_${GenericActions.enum.actionType.ITEM_CLEAR}`]: (state, action) => {
				if(AppUtils.isDev) {
					console.warn(`This is an item reducer. Did you mean "${actionPrefix}_${GenericActions.enum.actionType.ITEM_CLEAR}" instead of "${actionPrefix}_${GenericActions.enum.actionType.LIST_CLEAR}"?`);
				}
				return {
					...initialState,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.ITEM_CLEAR}`]: (state, action) => {
				return {
					...initialState,
				};
			},
			[`${actionPrefix}_${GenericActions.enum.actionType.CACHE_CLEAR}`]: (state, action) => {
				return {
					...state,
					lastUpdate: undefined,
				};
			},
		}
	}

	_handleModify(state, {modification = {}}) {
		const {type, path, value} = modification;

		let newEditData;
		if(this.cloneBeforeEdit) {
			newEditData = EO(this.shallowClone ? {...state.edit} : state.edit);

			if(!this.shallowClone) {
				newEditData = newEditData.clone();
			}
		}
		else {
			newEditData = EO(state.edit)
		}

		newEditData.modifyV2(value, path, type);

		return {
			edit: newEditData,
		};
	}
}
